import { Box, ButtonBase } from '@mui/material';
import { alpha } from '@mui/material/styles';
import ReactionIcon from 'components/common/ReactionIcon';
import PropTypes from 'prop-types';
import React, { useRef } from 'react';
import useOpenClose from 'utils/useOpenClose';
import ReactionDetails from './ReactionDetails';

const reactionBoxSx = (theme, active, canSeeDetails) => ({
  minWidth: 'unset',
  padding: '5px 7px 5px 6px',
  borderRadius: '999px',
  display: 'inline-flex',
  alignItems: 'center',
  gap: 0.5,
  fontSize: '14px',
  lineHeight: 1,
  backgroundColor:
    theme.palette.mode === 'light'
      ? alpha(theme.palette.action.hover, 0.05)
      : alpha(theme.palette.action.hover, 0.08),
  color: theme.palette.text.primary,
  margin: '2px 4px 2px 0',
  transition: 'all 100ms ease-in-out',
  ...(canSeeDetails &&
    (active
      ? {
          backgroundColor:
            theme.palette.mode === 'light'
              ? alpha(theme.palette.primary.main, 0.12)
              : alpha(theme.palette.primary.main, 0.2),
          color: theme.palette.primary.main,
          '&:hover': {
            backgroundColor:
              theme.palette.mode === 'light'
                ? alpha(theme.palette.primary.main, 0.15)
                : alpha(theme.palette.primary.main, 0.25),
          },
        }
      : {
          '&:hover': {
            backgroundColor:
              theme.palette.mode === 'light'
                ? alpha(theme.palette.action.hover, 0.08)
                : alpha(theme.palette.action.hover, 0.13),
          },
        })),
});

const ReactionCounter = ({ messageId, reaction, count, active, canSeeDetails }) => {
  const anchorRef = useRef(null);
  const [isOpen, open, close] = useOpenClose(false);

  const handleClick = event => {
    event.stopPropagation();
    open();
  };

  const Component = canSeeDetails ? ButtonBase : Box;
  return (
    <>
      <Component
        ref={anchorRef}
        onClick={handleClick}
        sx={theme => reactionBoxSx(theme, active, canSeeDetails)}
      >
        <Box
          component="span"
          sx={{
            display: 'flex',
            alignItems: 'center',
            height: 14,
          }}
        >
          <ReactionIcon name={reaction} size={13} />
        </Box>
        <Box
          component="span"
          sx={theme => ({
            fontSize: 'inherit',
            color: theme.palette.text.primary,
            display: 'flex',
            alignItems: 'center',
            height: 14,
          })}
        >
          {count}
        </Box>
      </Component>
      {canSeeDetails && (
        <ReactionDetails
          messageId={messageId}
          reaction={reaction}
          count={count}
          anchorRef={anchorRef}
          isOpen={isOpen}
          close={close}
        />
      )}
    </>
  );
};

ReactionCounter.propTypes = {
  messageId: PropTypes.string.isRequired,
  reaction: PropTypes.string.isRequired,
  count: PropTypes.number.isRequired,
  active: PropTypes.bool.isRequired,
  canSeeDetails: PropTypes.bool.isRequired,
};

export default ReactionCounter;
